import FuzzySearch from 'fuzzy-search';
import * as React from 'react';
import Search from '../search';
import { Search as Props, SearchItem } from './form-content.types';

const FormContentSearch: React.FC<Props> = ({
  searchInput,
  searchKeys,
  searchDataset,
  searchTerm = () => {},
  searchResult = () => {},
}) => {
  const [term, setTerm] = React.useState('');
  const searchOptions = { sort: true };

  const search = React.useMemo(() => {
    const searcher = new FuzzySearch<SearchItem>(
      searchDataset,
      searchKeys,
      searchOptions,
    );
    return (term: string) => searcher.search(term);
  }, [searchDataset]);

  const searchResults = React.useMemo(
    () => (term.length > 0 ? search(term) : []),
    [search, term],
  );

  React.useEffect(() => {
    searchResult(searchResults);
    searchTerm(term);
  });

  return (
    <div className="form-content__search">
      <Search
        {...searchInput}
        inputSize={Search.inputSizes.small}
        isLabelVisible={false}
        onChangeFunc={string => setTerm(string)}
      />
    </div>
  );
};

export default FormContentSearch;
